import script from "./CookieDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CookieDialog.vue?vue&type=script&setup=true&lang=js"

import "./CookieDialog.vue?vue&type=style&index=0&id=91a4f29e&lang=scss"

const __exports__ = script;

export default __exports__